import { Button, Tooltip, TooltipContent, TooltipTrigger } from "@elit-hair/elit-ui";
import { useTranslation } from "react-i18next";

import { DarwinAvatar } from "@/components/ai-chat/darwin-avatar";
import { DarwinSidebarToggleProps } from "@/components/ai-chat/types/darwin-sidebar-toggle.types";
import { DARWIN_AVATAR_SIZE } from "@/constants/ai-chat";
import { cn } from "@/lib/utils";

export function DarwinSidebarToggle({ isOpen, onToggle }: DarwinSidebarToggleProps) {
    const { t } = useTranslation();

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <Button
                    variant="ghost"
                    size="icon"
                    data-tour="ai-button"
                    onClick={onToggle}
                    aria-label={t("darwin")}
                    aria-pressed={isOpen}
                    className={cn(
                        "h-9 w-9 shrink-0 overflow-hidden rounded-full",
                        isOpen &&
                            "bg-gradient-to-br from-violet-500/25 via-fuchsia-500/20 to-cyan-500/25 ring-1 ring-violet-400/40"
                    )}
                >
                    <DarwinAvatar size={DARWIN_AVATAR_SIZE.TOGGLE} pointerFollow={false} className="pointer-events-none" />
                </Button>
            </TooltipTrigger>
            <TooltipContent side="bottom" sideOffset={5}>
                {t("darwin")}
            </TooltipContent>
        </Tooltip>
    );
}
